import { ChampDate } from './ChampDate.js'

/**
 * Sélecteur de date de NAISSANCE.
 *
 * ⭐ Un `ChampDate` borné, rien de plus. Le calendrier lui-même a été extrait
 * le jour où l'agenda en a eu besoin pour des dates futures : deux mécaniques
 * de saisie de date dans une même application, c'est deux endroits où corriger
 * le même défaut, et un jour deux comportements différents.
 *
 * ⚠️ Les bornes ne sont pas décoratives : elles reprennent celles du schéma
 * partagé. Une date FUTURE est toujours une faute de saisie, et au-delà de
 * 120 ans c'est presque toujours l'année courante tapée à la place de l'année
 * de naissance. Le calendrier ne doit jamais proposer ce que la validation
 * refusera.
 */
export function ChampDateNaissance({
  value,
  onChange,
  error,
  helperText,
}: {
  /** `AAAA-MM-JJ`, ou chaîne vide. */
  value: string
  onChange: (valeur: string) => void
  error?: boolean
  helperText?: string
}): JSX.Element {
  return (
    <ChampDate
      label="Date de naissance"
      value={value}
      onChange={onChange}
      max="today"
      min={new Date(new Date().getFullYear() - 120, 0, 1)}
      {...(error !== undefined ? { error } : {})}
      {...(helperText !== undefined ? { helperText } : {})}
    />
  )
}
